<template>
  <section id="comingsoon">
    <div>
      <!-- <img src="../assets/img/nutron-logo.png" alt="logo" class="img-fluid" /> -->
      <h1>Coming Soon...</h1>
    </div>
  </section>
</template>

<script>
export default {
  created() {}
};
</script>

<style scoped lang="scss">
#comingsoon {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: table;
    margin: 30px auto;
  }
  h1 {
    margin: 7em 0 5em 0;
    font-size: 2.5em;
    text-transform: uppercase;
  }
}
</style>